import React, { Fragment } from "react";

const FundFinder = () => {
  return (
    <Fragment>
      <p className="u-mt5">
        Search for available funds from over 200 programs and nine organizations on FundFinder.
      </p>
      <p>
        <a className="btn" href="https://fundfinder.panfoundation.org">
          Sign up
        </a>
      </p>
    </Fragment>
  );
};

export default FundFinder;
